/**
 * Planning sync-log client used by Schedule and Dispatch last-updated polling.
 */

import { apiRequest } from "./axios";
import { API_PATHS } from "../../config";

/**
 * Write one planning sync-log event to the backend stream.
 *
 * Payload is intentionally generic so both Schedule and Dispatch can reuse it.
 * @param {Object} body
 * @returns {Promise<Object>}
 */
export async function createPlanningSyncEvent(body) {
  return apiRequest(API_PATHS.PLANNING.SYNC_LOG, body, { method: "POST" });
}

/**
 * Read the newest planning sync-log event for persisted Last Modified display.
 *
 * @returns {Promise<Object|null>}
 */
export async function getPlanningLastUpdated() {
  return apiRequest(`${API_PATHS.PLANNING.SYNC_LOG}?latest=true`, null, {
    method: "GET",
  });
}

/**
 * Read planning sync-log events after a cursor timestamp.
 *
 * @param {{ since?: string, limit?: number }} [params]
 * @returns {Promise<{results?: Array<Object>, cursor?: string}>}
 */
export async function listPlanningSyncEvents({ since, limit } = {}) {
  const params = new URLSearchParams();
  if (since) {
    params.set("since", since);
  }
  if (Number.isFinite(limit) && limit > 0) {
    params.set("limit", String(limit));
  }
  const query = params.toString();
  const url = query
    ? `${API_PATHS.PLANNING.SYNC_LOG}?${query}`
    : API_PATHS.PLANNING.SYNC_LOG;
  return apiRequest(url, null, { method: "GET" });
}
